
const DrinkDetail = ({ items }) => {
    console.log(items);
    if (items.drinks) {
    return (
        <>
        {items.drinks.map((item) =>(
            <div className="grid grid-cols-3 box-border h-auto w-auto p-4 border-2">
                <div><h3 className="underline text-xl">{item.strDrink}</h3></div>
            <div>
            <p className="underline">Ingredients:</p>    
            <ul>                
                {item.strIngredient1 && item.strMeasure1 !== 'null' ? (
                    <li>{item.strIngredient1} - {item.strMeasure1}</li>
                ) : ( <></> )}
                {item.strIngredient2 && item.strMeasure2 !== 'null' ? (
                    <li>{item.strIngredient2} - {item.strMeasure2}</li>
                ) : ( <></> )}
                {item.strIngredient3 && item.strMeasure3 !== 'null' ? (
                    <li>{item.strIngredient3} - {item.strMeasure3}</li>
                ) : ( <></> )}
                {item.strIngredient4 && item.strMeasure4 !== 'null' ? (
                    <li>{item.strIngredient4} - {item.strMeasure4}</li>
                ) : ( <></> )}
                {item.strIngredient5 && item.strMeasure5 !== 'null' ? (
                <li>{item.strIngredient5} - {item.strMeasure5}</li>
                ) : ( <></> )}
                {item.strIngredient6 && item.strMeasure6 !== 'null' ? (
                <li>{item.strIngredient6} - {item.strMeasure6}</li>
                ) : ( <></> )}
                {item.strIngredient7 && item.strMeasure7 !== 'null' ? (
                <li>{item.strIngredient7} - {item.strMeasure7}</li>
                ) : ( <></> )}
                {item.strIngredient8 && item.strMeasure8 !== 'null' ? (
                <li>{item.strIngredient8} - {item.strMeasure8}</li>
                ) : ( <></> )}
                {item.strIngredient9 && item.strMeasure9 !== 'null' ? (
                <li>{item.strIngredient9} - {item.strMeasure9}</li>
                ) : ( <></> )}
                {item.strIngredient10 && item.strMeasure10 !== 'null' ? (
                <li>{item.strIngredient10} - {item.strMeasure10}</li>
                ) : ( <></> )}
            </ul>
            </div>
            <div>
            <p className="underline">How to?</p>
            <p>{item.strInstructions}</p>
            </div>
        </div>
        ))}
        </>
    ) } else{
        return <></>
    }
}

export default DrinkDetail